/**
 * 表示用ステータス
 * @enum {number}
 * @readonly
 * @property {number} UNANSWERED - 未回答
 * @property {number} TEMPORARILY_SAVED - 一時保存
 * @property {number} SUBMITTED - 提出済み
 * @property {number} SCORE_RATED - 評価済み
 * @property {number} ENDED - サーベイ終了済み
 */
export const AnswerDisplayStatus = {
  /**
   * 未回答
   */
  UNANSWERED: 1,
  /**
   * 一時保存(回答中)
   */
  TEMPORARILY_SAVED: 2,
  /**
   * 提出済み(回答済み)
   */
  SUBMITTED: 3,
  /**
   * 評価済み
   */
  SCORE_RATED: 4,
  /**
   * サーベイ終了済み
   */
  ENDED: 5,
  /**
   * 仮採点
   */
  AUTO_SCORED: 6,
} as const

export type AnswerDisplayStatus =
  (typeof AnswerDisplayStatus)[keyof typeof AnswerDisplayStatus]

/**
 * AnswerDisplayStatus であるか
 * @param value 任意の値
 * @returns boolean
 */
export const isAnswerDisplayStatus = (
  value: unknown,
): value is AnswerDisplayStatus => {
  return Object.values(AnswerDisplayStatus).includes(value as any)
}

export const ActiveAnswerDisplayStatus = Object.fromEntries(
  Object.entries(AnswerDisplayStatus).filter(([key]) => key !== 'ENDED'),
) as Omit<typeof AnswerDisplayStatus, 'ENDED'>

export type ActiveAnswerDisplayStatus =
  (typeof ActiveAnswerDisplayStatus)[keyof typeof ActiveAnswerDisplayStatus]

/**
 * 現在の調査票/サーベイが回答済みかどうか
 * @param value AnswerDisplayStatus
 * @returns boolean
 */
export const isAnswered = (
  value: AnswerDisplayStatus,
): boolean => {
  switch (value) {
    case AnswerDisplayStatus.TEMPORARILY_SAVED:
    case AnswerDisplayStatus.UNANSWERED:
      return false
    case AnswerDisplayStatus.SUBMITTED:
    case AnswerDisplayStatus.SCORE_RATED:
      return true
    case AnswerDisplayStatus.ENDED:
      return false
    case AnswerDisplayStatus.AUTO_SCORED:
      return true
    default:
      throw new Error(`${value satisfies never} is unexpected value`)
  }
}
